var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFordRidesHomeNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Information - Circle Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x81\x9A",
    d: "M15.5833 4.25C8.95422 4.25 3.58325 9.66935 3.58325 16.25C3.58325 22.879 8.95422 28.25 15.5833 28.25C22.1639 28.25 27.5833 22.879 27.5833 16.25C27.5833 9.66935 22.1639 4.25 15.5833 4.25ZM15.5833 9.57258C16.6962 9.57258 17.6155 10.4919 17.6155 11.6048C17.6155 12.7661 16.6962 13.6371 15.5833 13.6371C14.422 13.6371 13.551 12.7661 13.551 11.6048C13.551 10.4919 14.422 9.57258 15.5833 9.57258ZM18.2929 21.8629C18.2929 22.2016 18.0026 22.4436 17.7123 22.4436H13.4542C13.1155 22.4436 12.8736 22.2016 12.8736 21.8629V20.7016C12.8736 20.4113 13.1155 20.121 13.4542 20.121H14.0349V17.0242H13.4542C13.1155 17.0242 12.8736 16.7823 12.8736 16.4435V15.2823C12.8736 14.9919 13.1155 14.7016 13.4542 14.7016H16.551C16.8413 14.7016 17.1316 14.9919 17.1316 15.2823V20.121H17.7123C18.0026 20.121 18.2929 20.4113 18.2929 20.7016V21.8629Z",
    fill: "#00095B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFordRidesHomeNotificationsIcon);
export default __webpack_public_path__ + "static/media/ford-rides-home-notifications-icon.cba17be08257cfdb21a02809da32a90f.svg";
export { ForwardRef as ReactComponent };